export const completeFiloLogout = async (
  disposeConnections: () => Promise<void>,
  signOut: () => void,
): Promise<void> => {
  await disposeConnections();
  signOut();
};
